import React from 'react'

const AdditionalInfo = () => {
  return (
    <div>
      <h1>Additional Info Coming Soon...</h1>
    </div>
  )
}

export default AdditionalInfo
